<script>
	import {External, M} from "../../../external";

	export let template = {};

	if (template.name) {
		template.name += "_";
	}

	if (!template.category) {
		template.category = '0';
	}

	if (!template.language) {
		let locale = External.userLocale === "da_JK" ? "da" : External.userLocale;
		if (External.userLocale === "zh_JO") {
			External.usedLocale = "zh";
		}
		template.language = locale || "en";
	}

	export function getTemplate() {
		return template;
	}
</script>
<div class="popup-input-wrapper">
	<span class="help-text" style="margin-top: 0px">{M.WHATSAPP_TEMPLATE_SUBMIT_DESC}</span>
</div>
<div class="popup-input-wrapper">
	<div class="info">
		<h5>{M.NAME}</h5>
		<span>{M.WHATSAPP_TEMPLATE_NAME_DESC}</span>
	</div>
	<input type="text" placeholder="{M.NAME}" bind:value={template.name} class="focus transition-border" maxlength="512">
</div>
<div class="popup-input-wrapper">
	<div class="info">
		<h5>{M.LANGUAGE}</h5>
		<span>{M.TEMPLATE_LANGUAGE_DESC}</span>
	</div>
	<select class='page-select mt-5' bind:value={template.language}>
		<option value='0' disabled>{M.PLEASE_SELECT}</option>
		<option value="en">English</option>
		<option value="de">Deutsch</option>
		<option value="da">Dansk</option>
		<option value="es">Español</option>
		<option value="fr">Français</option>
		<option value="el">Ελληνικά</option>
		<option value="it">Italiano</option>
		<option value="nl">Nederlandse</option>
		<option value="nb">Norsk</option>
		<option value="pl">Polski</option>
		<option value="pt">Português</option>
		<option value="ro">Română</option>
		<option value="sv">Svenska</option>
		<option value="hu">Magyar</option>
		<option value="bg">Български</option>
		<option value="ru">Русский</option>
		<option value="uk">Українська</option>
		<option value="th">ไทย</option>
		<option value="zh">简体中文</option>
		<option value="iw">עִברִית</option>
		<option value="jp">日本人</option>
		<option value="ka">ქართული</option>
		<option value="lt">Lietuvis</option>
		<option value="ar">عربى</option>
		<option value="az">Azərbaycan</option>
		<option value="lv">Latvietis</option>
		<option value="vn">Tiếng Việt</option>
		<option value="sl">Slovenščina</option>
		<option value="sk">Slovák</option>
		<option value="af">Afrikaans</option>
		<option value="sr">Српски</option>
		<option value="tr">Türkçe</option>
		<option value="cs">čeština</option>
		<option value="hr">Hrvatski</option>
		<option value="et">Eesti keel</option>
		<option value="ko">한국어</option>
		<option value="hi">हिंदी</option>
	</select>
</div>
<div class="popup-input-wrapper">
	<div class="info">
		<h5>{M.CATEGORY}</h5>
		<span>{M.SELECT_WHATSAPP_CATEGORY_DESC}</span>
	</div>
	<select class='page-select mt-5' bind:value={template.category}>
		<option value='0' disabled>{M.PLEASE_SELECT}</option>
		<option value='MARKETING' style="padding-left: -20px; margin-left: -20px; text-indent: -20px">
			{M.WHATSAPP_MARKETING_CATEGORY_DESC}
		</option>
		<option value='UTILITY' style="padding-left: -20px; margin-left: -20px; text-indent: -20px">
			{M.WHATSAPP_UTILITY_CATEGORY_DESC}
		</option>
	</select>
</div>
